<template>
  <div class="row">
    <Row>
      <Col span="24">
        <Card :bordered="false">
            <p v-if="title" slot="title">{{title}}</p>
            <slot></slot>
        </Card>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
      /**
     * title 标题
     */
  props:['title'],  
}
</script>
<style scoped>
.row{
    margin-bottom: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/grid/grid.vue